import React, { useEffect, useState } from "react";
import { FormSection } from "../../../components";

import * as s from "./formPesquisa.module.css";

export default function FormPesquisaPorDeps({ handleConsulta, tops }) {
  const [consulta, setConsulta] = useState("");
  const [depsOpen, setDepsOpen] = useState(true);
  const [depsTop, setDepsTop] = useState("");

  const handleInput = (event) => {
    const { name, value } = event.target;
    setConsulta({ ...consulta, [name]: value });
  };

  useEffect(() => {
    handleConsulta(consulta);
    // eslint-disable-next-line
  }, [consulta]);

  const handleTop = (id, name) => {
    setConsulta({ ...consulta, [name]: id });
    setDepsTop("");
  };

  return (
    <div className="main-content">
      <div
        className="container__title-content"
        onClick={() => setDepsOpen(!depsOpen)}
      >
        <FormSection
          title="Pesquisa por DEP's"
          borderBottomWidth={361}
        ></FormSection>

        {!depsOpen ? (
          <div className="blue-arrow blue-arrow-down" />
        ) : (
          <div className="blue-arrow blue-arrow-up" />
        )}
      </div>

      <div className={`global-input-container ${depsOpen ? "slide" : ""}`}>
        <HeaderColumnsInputs />
        <HeaderColumnsInputs />
        <HeaderColumnsInputs />

        <div className="col-3">
          <div className="input">
            <label>MGT</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="mgtMin"
              id="mgtMin"
              value={consulta.mgtMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="mgtMax"
              id="mgtMax"
              value={consulta.mgtMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="mgtAccur"
              id="mgtAccur"
              value={consulta.mgtAccur || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("mgtTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.mgtTop || ""}
              name="mgtTop"
              id="mgtTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "mgtTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "mgtTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DP120</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dp120Min"
              id="dp120Min"
              value={consulta.dp120Min || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dp120Max"
              id="dp120Max"
              value={consulta.dp120Max || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dp120Acc"
              id="dp120Acc"
              value={consulta.dp120Acc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dp120Top");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dp120Top || ""}
              name="dp120Top"
              id="dp120Top"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dp120Top" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dp120Top");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DMAC</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dmacMin"
              id="dmacMin"
              value={consulta.dmacMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dmacMax"
              id="dmacMax"
              value={consulta.dmacMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dmacAcc"
              id="dmacAcc"
              value={consulta.dmacAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dmacTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dmacTop || ""}
              name="dmacTop"
              id="dmacTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dmacTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dmacTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DIPP</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dippMin"
              id="dippMin"
              value={consulta.dippMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dippMax"
              id="dippMax"
              value={consulta.dippMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dippAcc"
              id="dippAcc"
              value={consulta.dippAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dippTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dippTop || ""}
              name="dippTop"
              id="dippTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dippTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dippTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DP210</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dp210Min"
              id="dp210Min"
              value={consulta.dp210Min || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dp210Max"
              id="dp210Max"
              value={consulta.dp210Max || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dp210Acc"
              id="dp210Acc"
              value={consulta.dp210Acc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dp210Top");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dp210Top || ""}
              name="dp210Top"
              id="dp210Top"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dp210Top" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dp210Top");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DPCQ</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpcqMin"
              id="dpcqMin"
              value={consulta.dpcqMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpcqMax"
              id="dpcqMax"
              value={consulta.dpcqMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpcqAcc"
              id="dpcqAcc"
              value={consulta.dpcqAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dpcqTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dpcqTop || ""}
              name="dpcqTop"
              id="dpcqTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dpcqTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dpcqTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>D3P</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="d3pMin"
              id="d3pMin"
              value={consulta.d3pMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="d3pMax"
              id="d3pMax"
              value={consulta.d3pMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="d3pAcc"
              id="d3pAcc"
              value={consulta.d3pAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("d3pTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.d3pTop || ""}
              name="d3pTop"
              id="d3pTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "d3pTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "d3pTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DP365</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dp365Min"
              id="dp365Min"
              value={consulta.dp365Min || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dp365Max"
              id="dp365Max"
              value={consulta.dp365Max || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dp365Acc"
              id="dp365Acc"
              value={consulta.dp365Acc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dp365Top");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dp365Top || ""}
              name="dp365Top"
              id="dp365Top"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dp365Top" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dp365Top");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DPPC</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dppcMin"
              id="dppcMin"
              value={consulta.dppcMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dppcMax"
              id="dppcMax"
              value={consulta.dppcMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dppcAcc"
              id="dppcAcc"
              value={consulta.dppcAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dppcTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dppcTop || ""}
              name="dppcTop"
              id="dppcTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dppcTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dppcTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DIPM</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dipmMin"
              id="dipmMin"
              value={consulta.dipmMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dipmMax"
              id="dipmMax"
              value={consulta.dipmMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dipmAcc"
              id="dipmAcc"
              value={consulta.dipmAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dipmTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dipmTop || ""}
              name="dipmTop"
              id="dipmTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dipmTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dipmTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DP450</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dp450Min"
              id="dp450Min"
              value={consulta.dp450Min || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dp450Max"
              id="dp450Max"
              value={consulta.dp450Max || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dp450Acc"
              id="dp450Acc"
              value={consulta.dp450Acc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dp450Top");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dp450Top || ""}
              name="dp450Top"
              id="dp450Top"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dp450Top" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dp450Top");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DED</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dedMin"
              id="dedMin"
              value={consulta.dedMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dedMax"
              id="dedMax"
              value={consulta.dedMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dedAcc"
              id="dedAcc"
              value={consulta.dedAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dedTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dedTop || ""}
              name="dedTop"
              id="dedTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dedTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dedTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>MP120</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="mp120Min"
              id="mp120Min"
              value={consulta.mp120Min || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="mp120Max"
              id="mp120Max"
              value={consulta.mp120Max || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="mp120Acc"
              id="mp120Acc"
              value={consulta.mp120Acc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("mp120Top");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.mp120Top || ""}
              name="mp120Top"
              id="mp120Top"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "mp120Top" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "mp120Top");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DPAV</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpavMin"
              id="dpavMin"
              value={consulta.dpavMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpavMax"
              id="dpavMax"
              value={consulta.dpavMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpavAcc"
              id="dpavAcc"
              value={consulta.dpavAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dpavTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dpavTop || ""}
              name="dpavTop"
              id="dpavTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dpavTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dpavTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DPD</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpdMin"
              id="dpdMin"
              value={consulta.dpdMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpdMax"
              id="dpdMax"
              value={consulta.dpdMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpdAcc"
              id="dpdAcc"
              value={consulta.dpdAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dpdTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dpdTop || ""}
              name="dpdTop"
              id="dpdTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dpdTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dpdTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>MP210</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="mp210Min"
              id="mp210Min"
              value={consulta.mp210Min || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="mp210Max"
              id="mp210Max"
              value={consulta.mp210Max || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="mp210Acc"
              id="mp210Acc"
              value={consulta.mp210Acc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("mp210Top");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.mp210Top || ""}
              name="mp210Top"
              id="mp210Top"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "mp210Top" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "mp210Top");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DCAR</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dcarMin"
              id="dcarMin"
              value={consulta.dcarMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dcarMax"
              id="dcarMax"
              value={consulta.dcarMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dcarAcc"
              id="dcarAcc"
              value={consulta.dcarAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dcarTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dcarTop || ""}
              name="dcarTop"
              id="dcarTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dcarTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dcarTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DMD</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dmdMin"
              id="dmdMin"
              value={consulta.dmdMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dmdMax"
              id="dmdMax"
              value={consulta.dmdMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dmdAcc"
              id="dmdAcc"
              value={consulta.dmdAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dmdTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dmdTop || ""}
              name="dmdTop"
              id="dmdTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dmdTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dmdTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>MTP120</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="mtp120Min"
              id="mtp120Min"
              value={consulta.mtp120Min || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="mtp120Max"
              id="mtp120Max"
              value={consulta.mtp120Max || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="mtp120Acc"
              id="mtp120Acc"
              value={consulta.mtp120Acc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("mtp120Top");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.mtp120Top || ""}
              name="mtp120Top"
              id="mtp120Top"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "mtp120Top" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "mtp120Top");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DIMS</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dimsMin"
              id="dimsMin"
              value={consulta.dimsMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dimsMax"
              id="dimsMax"
              value={consulta.dimsMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dimsAcc"
              id="dimsAcc"
              value={consulta.dimsAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dimsTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dimsTop || ""}
              name="dimsTop"
              id="dimsTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dimsTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dimsTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DES</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="desMin"
              id="desMin"
              value={consulta.dimsMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="desMax"
              id="desMax"
              value={consulta.desMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="desAcc"
              id="desAcc"
              value={consulta.desAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("desTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.desTop || ""}
              name="desTop"
              id="desTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "desTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "desTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>MTP210</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="mtp210Min"
              id="mtp210Min"
              value={consulta.mtp210Min || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="mtp210Max"
              id="mtp210Max"
              value={consulta.mtp210Max || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="mtp210Acc"
              id="mtp210Acc"
              value={consulta.mtp210Acc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("mtp210Top");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.mtp210Top || ""}
              name="mtp210Top"
              id="mtp210Top"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "mtp210Top" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "mtp210Top");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DPE365</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpe365Min"
              id="dpe365Min"
              value={consulta.dpe365Min || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpe365Max"
              id="dpe365Max"
              value={consulta.dpe365Max || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpe365Acc"
              id="dpe365Acc"
              value={consulta.dpe365Acc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dpe365Top");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dpe365Top || ""}
              name="dpe365Top"
              id="dpe365Top"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dpe365Top" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dpe365Top");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DPS</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpsMin"
              id="dpsMin"
              value={consulta.dpsMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpsMax"
              id="dpsMax"
              value={consulta.dpsMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpsAcc"
              id="dpsAcc"
              value={consulta.dpsAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dpsTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dpsTop || ""}
              name="dpsTop"
              id="dpsTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dpsTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dpsTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DSTAY</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dstayMin"
              id="dstayMin"
              value={consulta.dstayMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dstayMax"
              id="dstayMax"
              value={consulta.dstayMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dstayAcc"
              id="dstayAcc"
              value={consulta.dstayAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dstayTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dstayTop || ""}
              name="dstayTop"
              id="dstayTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dstayTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dstayTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DPE450</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpe450Min"
              id="dpe450Min"
              value={consulta.dpe450Min || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpe450Max"
              id="dpe450Max"
              value={consulta.dpe450Max || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpe450Acc"
              id="dpe450Acc"
              value={consulta.dpe450Acc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dpe450Top");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dpe450Top || ""}
              name="dpe450Top"
              id="dpe450Top"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dpe450Top" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dpe450Top");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DMS</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dmsMin"
              id="dmsMin"
              value={consulta.dmsMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dmsMax"
              id="dmsMax"
              value={consulta.dmsMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dmsAcc"
              id="dmsAcc"
              value={consulta.dmsAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dmsTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dmsTop || ""}
              name="dmsTop"
              id="dmsTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dmsTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dmsTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DPAC</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpacMin"
              id="dpacMin"
              value={consulta.dpacMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpacMax"
              id="dpacMax"
              value={consulta.dpacMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpacAcc"
              id="dpacAcc"
              value={consulta.dpacAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dpacTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dpacTop || ""}
              name="dpacTop"
              id="dpacTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dpacTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dpacTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DAOL</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="daolMin"
              id="daolMin"
              value={consulta.daolMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="daolMax"
              id="daolMax"
              value={consulta.daolMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="daolAcc"
              id="daolAcc"
              value={consulta.daolAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("daolTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.daolTop || ""}
              name="daolTop"
              id="daolTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "daolTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "daolTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DALT</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="daltMin"
              id="daltMin"
              value={consulta.daltMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="daltMax"
              id="daltMax"
              value={consulta.daltMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="daltAcc"
              id="daltAcc"
              value={consulta.daltAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("daltTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.daltTop || ""}
              name="daltTop"
              id="daltTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "daltTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "daltTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DPG</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpgMin"
              id="dpgMin"
              value={consulta.dpgMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpgMax"
              id="dpgMax"
              value={consulta.dpgMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpgAcc"
              id="dpgAcc"
              value={consulta.dpgAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dpgTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dpgTop || ""}
              name="dpgTop"
              id="dpgTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "daltTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dpgTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DACAB</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dacabMin"
              id="dacabMin"
              value={consulta.dacabMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dacabMax"
              id="dacabMax"
              value={consulta.dacabMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dacabAcc"
              id="dacabAcc"
              value={consulta.dacabAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dacabTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dacabTop || ""}
              name="dacabTop"
              id="dacabTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "daltTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dacabTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DFRAME</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dframeMin"
              id="dframeMin"
              value={consulta.dframeMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dframeMax"
              id="dframeMax"
              value={consulta.dframeMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dframeAcc"
              id="dframeAcc"
              value={consulta.dframeAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dframeTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dframeTop || ""}
              name="dframeTop"
              id="dframeTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dframeTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dframeTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DPN</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpnMin"
              id="dpnMin"
              value={consulta.dpnMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpnMax"
              id="dpnMax"
              value={consulta.dpnMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dpnAcc"
              id="dpnAcc"
              value={consulta.dpnAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dpnTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dpnTop || ""}
              name="dpnTop"
              id="dpnTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dpnTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dpnTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-3">
          <div className="input">
            <label>DMAR</label>
            <input
              className="global-input input-placeholder"
              type="text"
              name="dmarMin"
              id="dmarMin"
              value={consulta.dmarMin || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dmarMax"
              id="dmarMax"
              value={consulta.dmarMax || ""}
              onChange={handleInput}
            />
          </div>
          <div className="input">
            <input
              className="global-input input-placeholder"
              type="text"
              name="dmarAcc"
              id="dmarAcc"
              value={consulta.dmarAcc || ""}
              onChange={handleInput}
            />
          </div>
          <div
            className="input"
            onClick={() => {
              if (depsTop !== "") {
                setDepsTop("");
              } else {
                setDepsTop("dmarTop");
              }
            }}
          >
            <input
              className="global-input input-placeholder"
              value={consulta.dmarTop || ""}
              name="dmarTop"
              id="dmarTop"
              type="text"
            />
            <div className="arrow-down" />
            {depsTop === "dmarTop" ? (
              <div className="input-dropdown__container">
                <ul className="input-dropdown__ul">
                  {tops &&
                    tops.length > 0 &&
                    tops.map((t, index) => (
                      <div key={index}>
                        <li
                          className="input-dropdown__li"
                          onClick={() => {
                            handleTop(t.key, "dmarTop");
                          }}
                        >
                          {t.value}
                        </li>
                        <div className="input-divider" />
                      </div>
                    ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

const HeaderColumnsInputs = () => {
  return (
    <div className={`col-3 ${s.rowColumns}`}>
      <div style={{ width: 45 }} />

      <div className={s.columnLabel}>
        <span>Min</span>
      </div>

      <div className={s.columnLabel}>
        <span>Max</span>
      </div>

      <div className={s.columnLabel}>
        <span>Accur(%)</span>
      </div>

      <div className={s.columnLabel}>
        <span>Top</span>
      </div>
    </div>
  );
};
